import React from 'react';
import IconBase from './IconBase';

const ChevronLeftIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M15,17.3c0.4-0.4,0.4-1,0-1.4L11.1,12L15,8.1c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L9,11.3c-0.4,0.4-0.4,1,0,1.4l4.6,4.6C14,17.7,14.6,17.7,15,17.3z"/>
        </IconBase>
    )
}

export default ChevronLeftIcon;